import { io } from "socket.io-client";
const ReminderPopups = require("../components/ReminderPopups")

const URL = process.env.REACT_APP_SERVER_URL || "http://localhost:5000";

const socket = io(URL, {
    auth: {
        userId: null,
    },
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
});

// socket.on("connect", () => console.log("Socket connected"));
// socket.on("connect_error", (err) => console.error("Socket error:", err.message));

export default socket